function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconArrowLeft = function IconArrowLeft(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M19 11L7.83 11L12.71 6.12003C13.1 5.73003 13.1 5.09003 12.71 4.70003C12.32 4.31003 11.69 4.31003 11.3 4.70003L4.71 11.29C4.32 11.68 4.32 12.31 4.71 12.7L11.29 19.3C11.68 19.69 12.31 19.69 12.7 19.3C13.09 18.91 13.09 18.28 12.7 17.89L7.83 13L19 13C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconArrowLeft));
//# sourceMappingURL=IconArrowLeft.js.map